<template>
  <v-card>
    <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
      Attributes
      <v-spacer></v-spacer>
      <v-text-field
        color="black"
        v-model="searchModel"
        clearable
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        rounded
        outlined
        dense
        class="py-1 px-5"
      ></v-text-field>
      <v-icon>{{ app.productIcon }}</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        :search="searchModel"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="attributeHeaders"
        :items="admin.attributeList"
        :items-per-page="15"
        no-data-text="NONE"
        :hide-default-footer="admin.attributeList.length == 0"
        :hide-default-header="admin.attributeList.length == 0"
      >
        <template v-slot:item.required="{ item }">
          <v-icon color="success" v-show="item.required">mdi-check</v-icon>
        </template>
        <template v-slot:item.productId="{ item }">
          {{ getProductSku(item.productId) }}
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="addNewAttribute"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        searchModel: null,
        attributeHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'NAME', value: 'name' },
          { text: 'DESC', value: 'description' },
          { text: 'CONTROL', value: 'controlType' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectionModel: {
        get() {
          return this.admin.selectedAttributeSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedAttributeSelectionModel',
            value: value
          });
          this.$store.dispatch('admin/getAttributeList');
        }
      }
    },
    methods: {
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(!row.isSelected);
      },
      /**
       * Adds a new Product Attribute to currently selected product
       */
      addNewAttribute() {
        this.$store.commit('admin/setSelectedAttribute', {
          id: 'new',
          name: '',
          description: '',
          controlType: ''
        });
        // auto tab switch
        this.$store.commit(
          'admin/setCurrentAttributeTab',
          this.admin.ATTRIBUTE_TABS.EDIT
        );
        // clear selection models
        this.clearChildSelectionModels();
        this.clearThisSelectionModel();
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit('admin/setSelectedAttribute', data.item);
          this.$store.dispatch('admin/getAttributeValueList', data.item.id);
          // auto tab switch
          this.$store.commit(
            'admin/setCurrentAttributeTab',
            this.admin.ATTRIBUTE_TABS.EDIT
          );
        } else {
          this.$store.commit('admin/setSelectedAttribute', null);
          // auto tab switch
          this.$store.commit(
            'admin/setCurrentAttributeTab',
            this.admin.ATTRIBUTE_TABS.LIST
          );
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears child selection models
       */
      clearChildSelectionModels() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedAttributeValueSelectionModel',
          value: null
        });
        this.$store.commit('admin/setSelectedAttributeValue', null);
        this.$store.commit('admin/setAttributeValueList', []);
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedAttributeSelectionModel',
          value: null
        });
      }
    }
  };
</script>
